import * as Reducers from './client.reducer';

export const ClientReducers = {
  Reducers,
};
